import { forwardRef } from 'react';
import { noop } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';

export const AlternativeVideoTab = forwardRef(
  (
    {
      onClick,
      onKeyDown,
      active,
      id,
      children,
      tabIndex,
      disabled = false,
      'aria-controls': ariaControls,
      'data-e2e': dataE2e,
    },
    ref
  ) => {
    const activeClass = active ? ' ct-video-tabs__alternative-nav-tab--active' : '';

    return (
      <button
        ref={ref}
        id={id}
        type="button"
        role="tab"
        disabled={disabled}
        aria-selected={active}
        aria-controls={ariaControls}
        tabIndex={tabIndex}
        data-e2e={dataE2e}
        className={`ct-video-tabs__alternative-nav-tab${activeClass}`}
        onClick={disabled ? noop : onClick}
        onKeyDown={disabled ? noop : onKeyDown}
      >
        {children}
        {active ? (
          <FontAwesomeIcon icon={faAngleUp} className="ct-nav-tab-icon" />
        ) : (
          <FontAwesomeIcon icon={faAngleDown} className="ct-nav-tab-icon" />
        )}
      </button>
    );
  }
);
